<template>
  <v-card>
    <v-card-title>
      <span class="headline">Engine Make</span>
    </v-card-title>
    <v-card-text>
      <message :messages="messages"></message>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6 v-if="newEngMake">
            <v-text-field :label="labels.vesEngMake" v-model="vesEngMakeForm.vesEngMake" :error-messages="errors.collect('vesEngMake')" data-vv-name="vesEngMake" :data-vv-as="labels.vesEngMake" v-validate="'required|param|max:8'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.vesEngMake}}</v-subheader>
            <div class="title">{{vesEngMakeForm.vesEngMake}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.vesEngMakeDesc" v-model="vesEngMakeForm.vesEngMakeDesc" :error-messages="errors.collect('vesEngMakeDesc')" data-vv-name="vesEngMakeDesc" :data-vv-as="labels.vesEngMakeDesc" v-validate="'required|entry|max:80'"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
      <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'newEngMake': Boolean,
    'vesEngMakeForm': Object
  },
  data() {
    return {
      labels: {
        vesEngMake: 'Engine Make*',
        vesEngMakeDesc: 'Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vesEngMakeForm.vesEngMake = undefined
      this.vesEngMakeForm.vesEngMakeDesc = undefined
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newEngMake) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURL = this.vesMenu.createVslEngMake
      if (apiURL) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURL, this.vesEngMakeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURL = this.vesMenu.updateVslEngMake
      if (apiURL) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURL, this.vesEngMakeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    }
  },
  computed: {
    vesMenu() {
      return this.$store.state.vessel.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
